<!-- <div #dialog> -->
  <!-- Modal Header -->
  <ng-container>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title" *ngIf="product.bomProductList">
        {{ "addCart.kitProductAdded2" | cxTranslate }}
      </div>
      <div class="cx-dialog-title modal-title" *ngIf="!product.bomProductList">
        {{ "addCart.itemAddedToCart2" | cxTranslate }}
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="dismissModal('Cross click')"
      >
        <span aria-hidden="true" class="show">   
          <i class="material-icons">close</i>
        </span>
      </button>
    </div>
    <!-- Modal Body -->
    <div class="cx-dialog-body modal-body">
      <div class="cx-dialog-row row">
        <div class="col-md-6">
          <div *ngIf="product" class="row">
            <div class="col-md-5">
              <cx-media
                class="rfqSearchTumbnail"
                [container]="product.images?.PRIMARY"
                [alt]="product.summary"
              >
              </cx-media>
            </div>

            <div class="col-md-7">
              <div class="dialog-product-code" >
                {{ product.code }}
              </div>
              <a
                [title]="product.name"
                [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
                class="dialog-product-name"
                [innerHTML]="product.nameHtml"
              ></a>
            </div>
          </div>
        </div>

        <div class="col-md-6 border-left">
          <div class="cx-dialog-buttons">
            <button
              class="vs-primary-btn"
              autofocus
              (click)="dismissModal('Continue Shopping')"
            >
            {{ "addCart.continueShopping" | cxTranslate }}
            </button>
            <button
              [class.disabled]="form.dirty"
              [routerLink]="{ cxRoute: 'quote/cart' } | cxUrl"
              class="vs-tertiary-btn"
              autofocus
              (click)="!form.dirty && dismissModal('View Quote cart')"
            >
            {{ "addCart.viewQuoteCart" | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        {{ "addCart.updatingCart" | cxTranslate }}
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="dismissModal('Cross click')"
      >
        <span aria-hidden="true">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>
    <!-- Modal Body -->
    <div class="cx-dialog-body modal-body">
      <div class="cx-dialog-row">
        <div class="col-sm-12"><cx-spinner></cx-spinner></div>
      </div>
    </div>
    </div>
    </div>
  </ng-template>
<!-- </div> -->
